import React from "react";
import ProposalRow from "../../Interface/ProposalRow/ProposalRow";
import {useEthereum} from "../../../EthereumContext";
import Separator from "../../Interface/Separator/Separator";
import {useDispatch, useSelector} from "react-redux";
import {fetchProposalData, fetchProposalState} from "../../../redux/governor";
import {splitDescription} from "../../../utils";

function Proposal({proposal, open, isLast, block}) {
    const {governor} = useEthereum();
    const state = useSelector(store => store.governor.proposalStates[proposal?.id]);
    const data = useSelector(store => store.governor.proposalData[proposal?.id]);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!open && proposal?.id) {
            dispatch(fetchProposalState({governor}, proposal?.id));
        }
    }, [proposal?.id, governor, open, dispatch]);

    React.useEffect(() => {
        if (open && proposal?.id) {
            dispatch(fetchProposalData({governor}, proposal?.id));
        }
    }, [proposal?.id, governor, open, dispatch]);

    const [remaining, setRemaining] = React.useState(
        (proposal.endBlock - block) * process.env.REACT_APP_BLOCK_TIME
    );

    React.useEffect(() => {
        const timer = setTimeout(() => {
            setRemaining(remaining - 1000);
        }, 1000);
        return () => clearTimeout(timer);
    });

    const {title, other} = splitDescription(proposal.description);

    return (
        <React.Fragment>
            <ProposalRow
                id={proposal.id}
                title={title}
                description={other}
                open={open}
                state={state}
                remaining={remaining}
                data={data}
            />
            {!isLast && <Separator />}
        </React.Fragment>
    )
}

export default Proposal;
